module.exports = __webpack_public_path__ + "fonts/436d401.ttf";